import { jsx as _jsx } from "react/jsx-runtime";
import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { UIGroup } from 'z3k-config';
import { getDeviceSpec } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { CustomIcon } from 'console/shared/components/icon/custom';
import { CustomTab } from './tab';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { custom_tab_icons } from 'console/shared/components/fields/icon/icons';
import { compressionByField } from 'webui/utils/sort';
export const noTabs = [];
export function getZ3KCustomTabs(device) {
    const { capabilities, device_type, z3k_config, hardware_type } = device;
    if (!LegacyDevice.has_capability(capabilities, Capability.has_z3k_settings)) {
        return noTabs;
    }
    if (device_type?.code == null || device.hardware_type?.code == null) {
        return noTabs;
    }
    if (!getDeviceSpec(device_type?.code, hardware_type?.code ?? '').has_ui_groups) {
        return noTabs;
    }
    //FIXME after add immutable sort
    const ui_groups = UIGroup.get
        .where(z3k_config, ({ is_hidden }) => !is_hidden)
        .slice();
    return ui_groups.sort(compressionByField('position')).map((ui_group) => {
        const icon = custom_tab_icons.find((icon) => icon.id == ui_group.icon);
        return {
            key: `${DefaultTabKey.custom_tab}-${ui_group.id}`,
            title: ui_group.name,
            iconclass: '',
            icon: icon ? (_jsx(CustomIcon, { Icon: icon.render, width: 26, height: 26 })) : null,
            should_appear: () => true,
            render: ({ r_device }) => (_jsx(CustomTab, { ui_group: ui_group, device: r_device })),
        };
    });
}
